<template>
  <div class="hello">
    <h3 class="text-center">{{ msg }}</h3>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Wydawnictwo WAM'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Home.vue